<div class="container">
  <div class="mt-3">
    <h4>Revise e assine o termo</h4>   
  </div>
  
  <app-pdf-document class="top-32" [src]="pdfSrc()"></app-pdf-document>
  
  <div class="d-flex justify-content-center top-64">
    <vivest-checkbox
      label-variant="single-line"
      name="aceite-termo"
      required
      [checked]="aceiteTermo()"
      (change)="onAceiteChange($event)"
    >
      Li e estou de acordo
    </vivest-checkbox>
  </div>
  
  <div class="d-flex justify-content-center align-items-center buttons top-32">
    <vivest-button variant="outline" size="md" (click)="onReturn()">
      Voltar
    </vivest-button>
    <vivest-button variant="primary" size="md" [disabled]="!aceiteTermo()" (click)="onSubmit()">
      <vivest-icon slot="icon-left" name="check-circle" source="feather"></vivest-icon>
      Assinar termo
    </vivest-button>
  </div>
  
  <!-- Aberto só depois que a assinatura do termo retorna sucesso. -->
  <vivest-modal
    heading="Solicitação enviada com sucesso!"
    description="Fique atento(a) ao seu email cadastrado na Vivest"
    dismissible
    [hasIcon]="true"
    [open]="openModalSucesso()"
    (vivest-close)="closeModalSucesso()"
    style="--vivest-color-text-heading: #1B894A"
  >
    <img slot="icon" src="assets/images/icons/Check.svg" alt="" />
    <vivest-button slot="actions" variant="outline" size="md" (click)="onClick()">Ver detalhes</vivest-button>
  </vivest-modal>
</div>